import React from 'react';

function TextField(props) {
  const fieldProps = {};
  if (!props.hasOwnProperty('aria-label') && props.hasOwnProperty('placeholder')) {
    fieldProps['aria-label'] = props.placeholder;
  }
  return (
    <input type="text" {...props} {...fieldProps}/>
  );
}

export default TextField;
